module.exports = __webpack_public_path__ + "static/media/iconfinder_social_media_applications_3-instagram_4102579.2679dcde.svg";